module.exports = __webpack_public_path__ + "img/arrow-left.4859773b.svg";